(() => {
  const form = document.getElementById('conShopifyForm');
  const flow = document.getElementById('conFlow');
  if (!form || !flow) return;

  const state = { where: [], since: '', worst: '', words: '', name: '', contact: '' };
  const labels = { 1: 'Where it shows up', 2: 'What the pattern is', 3: 'How we reach you' };
  const toast = (m) => (window.LUME && LUME.toast ? LUME.toast(m) : alert(m));

  const showStep = (n) => {
    flow.querySelectorAll('.con-step').forEach((el) => {
      el.classList.toggle('active', Number(el.dataset.step) === n);
    });
    const label = document.getElementById('conDotLabel');
    if (label) label.textContent = labels[n] || '';
    const b = document.querySelector('#conDots b');
    if (b) b.textContent = String(n).padStart(2, '0');
  };

  const isPhone = (v) => /^(\+?92|0)?3\d{9}$/.test(String(v).replace(/[\s-]/g, ''));
  const isEmail = (v) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v).trim());

  const updateWaVisibility = () => {
    const btn = document.getElementById('conWaBtn');
    if (!btn) return;
    const contact = document.getElementById('conContact')?.value.trim() || '';
    const wa = (document.documentElement.dataset.lumeWa || '').replace(/\D/g, '');
    btn.hidden = !(wa && isPhone(contact));
  };

  const showDone = () => {
    flow.hidden = true;
    flow.style.display = 'none';
    const dots = document.getElementById('conDots');
    if (dots) dots.hidden = true;
    const done = document.getElementById('conDone');
    if (done) {
      done.hidden = false;
      done.classList.add('active');
    }
  };

  const fillHidden = () => {
    state.name = document.getElementById('conName')?.value.trim() || '';
    state.contact = document.getElementById('conContact')?.value.trim() || '';
    state.words = document.getElementById('conWords')?.value.trim() || '';

    const emailEl = document.getElementById('conHiddenEmail');
    const phoneEl = document.getElementById('conHiddenPhone');
    const bodyEl = document.getElementById('conHiddenBody');
    const whereEl = document.getElementById('conHiddenWhere');
    const sinceEl = document.getElementById('conHiddenSince');
    const worstEl = document.getElementById('conHiddenWorst');
    const notify = form.querySelector('[data-shop-notify]')?.value || 'infolumekeys@gmail.com';

    if (whereEl) whereEl.value = state.where.join(', ');
    if (sinceEl) sinceEl.value = state.since;
    if (worstEl) worstEl.value = state.worst;

    if (isEmail(state.contact)) {
      if (emailEl) emailEl.value = state.contact;
      if (phoneEl) phoneEl.value = '';
    } else {
      /* Shopify contact forms require an email field — use store notify address when customer gave a phone */
      if (emailEl) emailEl.value = notify;
      if (phoneEl) phoneEl.value = state.contact;
    }

    const bodyLines = [
      'LUME Consultation request',
      '',
      'Name: ' + state.name,
      'Reply to: ' + state.contact,
      'Where: ' + state.where.join(', '),
      'Since: ' + state.since,
      'Worst: ' + state.worst,
      'Note: ' + (state.words || '—'),
    ];
    if (bodyEl) bodyEl.value = bodyLines.join('\n');
  };

  flow.addEventListener('click', (e) => {
    const chip = e.target.closest('.con-chip');
    if (chip) {
      const groupEl = chip.closest('.con-chips');
      const g = groupEl?.dataset.group;
      if (!g) return;
      const multi = groupEl.dataset.multi === '1';
      if (multi) {
        chip.classList.toggle('on');
        state.where = Array.from(groupEl.querySelectorAll('.con-chip.on')).map(
          (c) => c.dataset.val || c.textContent.trim()
        );
      } else {
        groupEl.querySelectorAll('.con-chip').forEach((c) => c.classList.remove('on'));
        chip.classList.add('on');
        state[g] = chip.dataset.val || chip.textContent.trim();
      }
      return;
    }

    const next = e.target.closest('[data-con-next]');
    if (next) {
      const n = Number(next.dataset.conNext);
      if (n === 2 && !state.where.length) return toast('Pick where it shows up');
      if (n === 3) {
        if (!state.since) return toast('Pick how long it has been there');
        if (!state.worst) return toast('Pick when it is worst');
        state.words = document.getElementById('conWords')?.value.trim() || '';
        const sum = document.getElementById('conSum');
        if (sum) {
          sum.hidden = false;
          sum.textContent =
            'Where: ' +
            state.where.join(', ') +
            ' · Since: ' +
            state.since +
            ' · Worst: ' +
            state.worst +
            (state.words ? ' · Note: ' + state.words : '');
        }
        updateWaVisibility();
      }
      showStep(n);
    }
  });

  /* WhatsApp — optional alternate path (still opens WA; email goes through Shopify) */
  document.getElementById('conWaBtn')?.addEventListener('click', (e) => {
    e.preventDefault();
    state.name = document.getElementById('conName')?.value.trim() || '';
    state.contact = document.getElementById('conContact')?.value.trim() || '';
    state.words = document.getElementById('conWords')?.value.trim() || '';
    if (!state.name || !state.contact) return toast('Add your name and contact');
    const wa = (document.documentElement.dataset.lumeWa || '').replace(/\D/g, '');
    if (!wa) return;
    const body = encodeURIComponent(
      [
        'LUME Consultation',
        'Name: ' + state.name,
        'Contact: ' + state.contact,
        'Where: ' + state.where.join(', '),
        'Since: ' + state.since,
        'Worst: ' + state.worst,
        'Note: ' + (state.words || '—'),
      ].join('\n')
    );
    window.open('https://wa.me/' + wa + '?text=' + body, '_blank');
    showDone();
  });

  form.addEventListener('submit', (e) => {
    state.name = document.getElementById('conName')?.value.trim() || '';
    state.contact = document.getElementById('conContact')?.value.trim() || '';
    if (!state.name || !state.contact) {
      e.preventDefault();
      return toast('Add your name and contact');
    }
    if (!state.where.length) {
      e.preventDefault();
      showStep(1);
      return toast('Pick where it shows up');
    }
    if (!state.since || !state.worst) {
      e.preventDefault();
      showStep(2);
      return toast('Complete the pattern questions');
    }
    fillHidden();
    const btn = document.getElementById('conEmailBtn');
    if (btn) {
      btn.disabled = true;
      btn.textContent = 'Sending…';
    }
    /* Let the browser POST the Shopify contact form — merchant gets email in Admin */
  });

  document.getElementById('conContact')?.addEventListener('input', updateWaVisibility);
  showStep(1);
})();
